<nz-input-group>
  <input
    #input
    type="text"
    nz-input
    class="ant-input"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [textMask]="{
            mask: phoneMaskFunction,
            pipe: phonePipe,
            guide: true,
            keepCharPositions: false
        }"
    autocomplete="off"
  />
</nz-input-group>
<ng-container *ngIf="formControl.errors && formControl.touched">
  <div class="errors" *ngIf="formControl.errors && formControl.errors.required">
    <div class="error">Обязательное поле</div>
  </div>
</ng-container>
